import Vue from 'vue'

const translations = {
  en: {
    // Firebase auth error messages
    'auth/wrong-password': 'The password is invalid or the user does not have a password',

    'association with params': '#{person} from cell #{cell}',
    'Confirm delete #{param}': 'Are you sure you want to delete<br>#{param}?',
    'Meeting date already exists': 'Meeting on "#{param}" already exists.',
    'meeting with params': 'meeting on #{param}'
  },

  pl: {
    // Firebase auth error messages
    'auth/wrong-password': 'Nieprawidłowe hasło lub użytkownik nie ma hasła',
    'auth/user-not-found': 'Nie zarejestrowano użytkownika o e-mailu: #{param}',
    'auth/invalid-email': 'Niepoprawny email',
    'The email address is badly formatted.': 'Niepoprawny format e-maila: #{param}',
    'The password is invalid or the user does not have a password.': 'Nieprawidłowe hasło lub użytkownik nie ma hasła: #{param}',
    'There is no user record corresponding to this identifier. The user may have been deleted.': 'W aplikacji nie zarejestrowano użytkownika dla tego e-maila: #{param}',

    'A AL ASL G L M N SL SP P V': 'A ZL ZLS G L CZ N LS DR P W',
    'Add person': 'Dodaj osobę',
    'Administrator': 'Administrator',
    'Assigned to another cell': '#{person} pełni rolę #{roleName} w grupie #{cell} w podanym okresie od #{from} do #{to}',
    'Assignment end < last meeting': 'Na podstawie tego powiązania została utworzona lista osób na spotkaniu #{param} i dlatego nie można zakończyć powiązania przed tym dniem. Chcesz zakończyć powiązanie w dniu #{param}?',
    'Assignment periods overlap': 'Ta osoba jest już przypisana <br>do grupy #{cell} jako #{roleName}<br> w okresie #{start} &#8596; #{end}',
    'Assignment used in meetings': 'Nie można usunąć tego przypisania, ponieważ na jego podstawie została utworzona lista osób na spotkaniu spotkaniu #{param}',
    'Associative Leader': 'Zastępca Lidera',
    'Associative Sectional Leader': 'Zastępca Lidera Sekcyjnego',
    'At least 8 characters': 'Przynajmniej 8 znaków',
    'Attendance': 'Frekwencja',
    'Attendance without guests': 'Frekwencja bez gości',
    'Authentication': 'Kim jesteś?',
    'Authentication in progress...': 'Trwa sprawdzanie tożsamości...',
    'Average frequency': 'Średnia frekwencja',
    'Average frequency of members on meetings': 'Średnia frekwencja członków grupy na spotkaniach',
    'Average person count': 'Średnia liczba osób',
    'Average person count on a meeting': 'Średnia liczba osób na spotkaniu',
    'always': 'zawsze',
    'assignment with params': '<span class="bold">#{person}</span> z grupy <span class="bold">#{cell}</span>',
    'Can be empty': 'To pole może być puste',
    'Cannot change role twice a day': 'Nie można zmienić roli rozpoczętej dzisiaj',
    'Cannot remove before date': 'Nie można usuwać spotkań dalej niż 30 dni wstecz, czyli przed #{param}',
    'Cancel': 'Anuluj',
    'Cell': 'Grupa',
    'Cell report': 'Zestawienie grup',
    'Cell type': 'Typ grupy',
    'Cells': 'Grupy',
    'Change name': 'Czy jesteś pewien, że chcesz zmienić nazwę osoby, również we wszystkich zapisanych spotkaniach,  z #{oldName} na #{newName}?',
    'Change role': 'Czy chcesz zakończyć rolę #{oldRole} z dniem #{to} i rozpocząć rolę #{newRole} od dnia #{from} dla #{person}?',
    'Change the end of assignment?': 'Czy zakończyć przypisanie z dniem #{param}?',
    'Close': 'Zamknij',
    'Composition': 'Skład',
    'Confirm delete #{param}': 'Czy jesteś pewien, że chcesz usunąć #{param}?',
    'Confirmation': 'Potwierdzenie',
    'Content': 'Treść',
    'Content placeholder': 'Kliknij tu, aby podać treść spotkania:\n1. Przełamywanie lodów\n2. Wielbienie\n3. Wzrost\n4. Wychodzenie\n5. Wzmacnianie wizji\nUwagi i pytania do twojego lidera/pastora',
    'Copied to clipboard': 'Skopiowano do schowka',
    'Correct person name': 'Popraw nazwę osoby',
    'Count of cell meetings': 'Ilość spotkań danej grupy',
    'Copy to clipboard': 'Kopiuj do schowka',
    'Count': 'Ilość',
    'Current': 'Bieżący',
    'Current composition': 'Bieżący skład',
    'Date incorrect': 'Data niepoprawna',
    'Delete': 'Usuń',
    'Delete assignment': 'Usuń przypisanie',
    'Delete meeting': 'Usuń spotkanie',
    'Description': 'Opis',
    'Dirty check message': 'Dokonano zmian w formularzu, jeśli przyciśniesz "Tak" zmiany zostaną zapisane i twoja akcja zostanie wykonana, jeśli naciśniesz "Nie" zmiany nie zostaną zapisane i twoja akcja zostanie wykonana, jeśli naciśniesz "Anuluj" to tylko zamkniesz niniejszy komunikat.',
    'Email disclaimer': 'Nie odpowiadaj na tego maila do nadawcy, ponieważ jest on automatem.',
    'Email from': 'KJCh cell app <office@netanel.pl>',
    'Email report to': 'Wyślij raport do',
    'End > start': 'Data końcowa musi być większa od daty początkowej',
    'End assignment': 'Zakończ przypisanie',
    'End assignment?': 'Czy na pewno chcesz zakończyć to przypisanie?',
    'Error': 'Błąd',
    'Frequency': 'Frekwencja',
    'From': 'Od',
    'Intro': 'Kliknij na ikonę w lewym górnym rogu aby wyświetlić menu. Ekran "Osoby" pozwala zdefiniować skład grupy, natomiast ekran "Spotkania" pozwala raportować frekwencję na spotkaniach grupy.',
    'Fix errors': 'Popraw najpierw błędy (zaznaczone na czerwono)',
    'From when': 'Od kiedy',
    'Guest': 'Gość',
    'Go back': 'Powrót do poprzedniego ekranu',
    'Half year': 'Pół roku',
    'Has that role already': '#{person} ma już rolę #{roleName} w tej grupie',
    'History': 'Historia',
    'Information': 'Informacja',
    'Last half of year': 'Poprzednia połowa roku',
    'Last meeting date': 'Data ostatniego spotkania',
    'Last month': 'Poprzedni miesiąc',
    'Last quarter': 'Poprzedni kwartał',
    'Last year': 'Poprzedni rok',
    'Leader': 'Lider',
    'Leaders cell': 'Grupa liderska',
    'Legend': 'Legenda',
    'Mark members of the new group': 'Zaznacz osoby do nowej grupy',
    'Meeting': 'Spotkanie',
    'Meeting date': 'Data spotkania',
    'Meeting dates out of range': 'Osoba #{person} wzięła w udział w spotkaniach: #{first}#{space}#{last}, które wykracza(ją) poza zakres przypisania tej osoby: #{start} <-> #{end}. Czy zmieniać zakres przypisania tej osoby, żeby objąć wszystkie daty spotkań, w których wzięła udział?',
    'Meeting date already exists': 'Spotkanie z datą "#{param}" już zostało wprowadzone.',
    'Meeting email subject': 'Raport od #{cellDesc} z #{date}',
    'Meetings': 'Spotkania',
    'Meetings frequency in weeks': 'Średni odstęp między spotkaniami w tygodniach',
    'Meeting span': 'Odstęp między spotkaniami',
    'Meeting span in weeks': 'Średni odstęp między spotkaniami w tygodniach',
    'Meeting must have at least two person attended': 'Spotkanie wymaga obecności przynajmniej dwóch osób',
    'Member': 'Członek',
    'Members': 'Skład',
    'Month': 'Miesiąc',
    'Multiplication': 'Pomnożenie',
    'Multiply': 'Pomnóż',
    'meeting with params': 'spotkanie z dnia #{param}',
    'Name': 'Nazwa',
    'New assignment': 'Nowe przypisanie',
    'New group': 'Symbol nowej grupy',
    'New group hint': 'Trzy-literowy symbol nowej grupy',
    'New meeting': 'Nowe spotkanie',
    'New role': 'Nowa rola',
    'Nobody signed in': 'Nikt nie jest zalogowany',
    'No': 'Nie',
    'no': 'nie',
    'No user with such email': 'Nie zarejestrowano użytkownika o emailu #{param}',
    'Number of meetings': 'Ilość spotkań',
    'Number of persons': 'Ilość osób',
    'Number of persons visiting during the period': 'Łączna liczba osób, która pojawiła się na spotkaniach w danym okresie',
    'Open cell': 'Grupa otwarta',
    'Open groups in the section': 'Otwarte grupy w sekcji',
    'Or sign in with': 'Lub przedstaw się za pomocą konta',
    'Parameters': 'Parametry',
    'Password': 'Hasło',
    'Perform': 'Wykonaj',
    'Person': 'Osoba',
    'person #{param}': 'osobę #{param}',
    'Person #{param} enlisted already': 'Osoba #{param} jest już na liście',
    'Person list': 'Lista osób',
    'Person report': 'Zestawienie osób',
    'Persons': 'Osoby',
    'Persons count': 'Ilość osób na spotkaniu',
    'Previous': 'Poprzedni',
    'Range': 'Zakres',
    'Report': 'Zestawienie',
    'Required': 'Pole jest wymagane',
    'Removed': 'Usunięto',
    'Reports': 'Raporty',
    'Return to top group': 'Wróć do mojej grupy',
    'Role': 'Rola',
    'Role does not have access': 'Użytkownik #{email} z rolą #{role} nie ma dostępu do systemu',
    'Run': 'Wio!',
    'Quarter': 'Kwartał',
    'Save': 'Zapisz',
    'Save don\'t send': 'Zapisz bez wysyłania',
    'Save and send': 'Zapisz i wyślij',
    'Saved': 'Zapisano',
    'Section': 'Sekcja',
    'Sections': 'Sekcje',
    'Sectional Leader': 'Lider Sekcyjny',
    'Select': 'Wybierz',
    'Select a group below': 'Wybierz grupę poniżej',
    'Send the changes?': 'Czy wysłać zmiany?',
    'Sent': 'Wysłano',
    'Set the end on the last meeting?': 'Czy ustawić datę na ostatnie spotkanie?',
    'Sign in': 'Wpuść mnie',
    'Sign out': 'Wyloguj',
    'Simple': 'Prosto',
    'Spiritual Parent': 'Duchowy Rodzic',
    'Start < end': 'Data początkowa musi być mniejsza od daty końcowej',
    'Start date must after last meeting': 'Data rozpoczęcia musi być późniejsza niż data ostatniego spotkania: #{param}',
    'Start date must later than': 'Data rozpoczęcia musi być późniejsza niż #{param}',
    'Stats headers': 'Grupa % Obec Czł Gość Wizyt',
    'Subcell': 'Podgrupa',
    'Subgroup name': 'Nazwa podgrupy',
    'Sum of attendance': 'Suma obecności',
    'Symbol': 'Symbol',
    'This month': 'Ten miesiąc',
    'This quarter': 'Ten kwartał',
    'This year': 'Ten rok',
    'This half of year': 'Ta połowa roku',
    'To': 'Do',
    'To when': 'Do kiedy',
    'Total': 'Razem',
    'Until now': 'Do teraz',
    'User cell does not exist': 'Grupa "#{param}", do której jesteś przypisany(a) nie istnieje',
    'Visitor': 'Wizytator',
    'Welcome': 'Witaj!',
    'Yes': 'Tak',
    'Year': 'Rok',
    'yes': 'tak',
    'this assignment': 'to przypisanie'
  }
}

function makeBold(param) {
  return `<span class="bold">${param}</span>`
}

var locale = 'pl'

export function setLocale(loc) {
  locale = loc
}

export function t(key, params, bold = true) {
  if (!key) return ''
  const items = translations[locale]
  var s = (items && items[key]) || key
  const pp = (typeof params === 'string') ? {
    param: params
  } :
    params instanceof Object ? params : {}
  Object.keys(pp).forEach(key => {
    const p = bold ? makeBold(pp[key]) : pp[key]
    s = s.replace(new RegExp(`#{${key}}`, 'g'), p)
  })
  s = s.replace(/#{\w+}/g, '')
  return s
}

Vue.mixin({
  methods: {
    t
  }
})
